import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useStyles } from "./RankCard.style";
import { Skeleton } from "@onmo/ui";
import { random } from "lodash-es";

export const RankCardLoading: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const classes = useStyles();
  const { className, ...otherProps } = props;

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <div className={classes.userContent}>
        <Skeleton variant="circle" width={50} height={50} />
        <div className={classes.content}>
          <Skeleton variant="text" width={random(50, 100)} height={20} />
          <Skeleton variant="text" width={random(100, 150)} height={20} />
        </div>
      </div>
      <div className={classes.reward}>
        <Skeleton variant="text" width={50} height={20} />
      </div>
    </div>
  );
};

export default RankCardLoading;
